import { useDidUpdateEffect } from 'lib/utils';
import React, { useEffect, useState } from 'react';
import { useShallowAppSelector } from 'store/hooks';
import {
  AppActions,
  BaseActions,
  PatientActions,
  PmsActions,
  ProjectActions,
} from 'store/actionCreators';
import { isLogInSelector, signInUser, signOut } from 'store/modules/auth';
import storage, { keys } from 'lib/storage';
import { PatientInfoFormInput } from 'containers/patient/PatientModalContainer';
import { makeCaseIdFnClinic } from 'lib/library';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { T } from 'components/common/text';
import { isClinicUserSelector } from 'store/modules/user';
import { pageUrl } from 'lib/mapper';

export const pmsStartProject = 'startProject';
export const pmsViewThumbnail = 'viewThumbnail';

function PmsConnect() {
  const {
    isLogIn,
    fetchProfile: { profile: userProfile },

    isClinicUser,
    newPatient: { patientInfo: newPatient, msg },
    newPatientSuccess,
    projectInit: { projectCount: projectCount },
    projectInitSuccess,
    editProjectData,
    editProjectSuccess,
    createProjectData,
    createProjectSuccess,
    isPmsReady,
    isPmsOrder,
    pmsCommand,
    pmsData,
  } = useShallowAppSelector(state => ({
    isLogIn: isLogInSelector(state),
    fetchProfile: state.user.fetchProfile.data || {},

    isClinicUser: isClinicUserSelector(state),
    newPatient: state.patient.newPatient.data || { patientInfo: {}, msg: {} },
    newPatientSuccess: state.patient.newPatient.success,
    projectInit: state.project.initProject.data || { projectCount: {} },
    projectInitSuccess: state.project.initProject.success,
    editProjectData: state.project.editProject.data,
    editProjectSuccess: state.project.editProject.success,
    createProjectData: state.project.createProject.data,
    createProjectSuccess: state.project.createProject.success,
    isPmsReady: state.pms.isPmsReady,
    isPmsOrder: state.pms.isPmsOrder,
    pmsCommand: state.pms.command,
    pmsData: state.pms.pmsData,
  }));
  const { t } = useTranslation();

  const { ipcRenderer } = window;
  const loginUser = storage.get(keys.user);
  const history = useHistory();
  const location = useLocation();
  const [newPatientData, setNewPatientData] = useState<PatientInfoFormInput>();
  const [isUseablePms, setIsUseablePms] = useState<boolean>(false);

  useDidUpdateEffect(() => {
    if (!createProjectSuccess || !isPmsOrder) return;
    if (pmsCommand === pmsStartProject) {
      history.push(
        `/project/creating/${createProjectData.projectInformation.projectCode}?pathTo=detail&scanStart=1&tab=0`,
      );
      handleClearPmsData();
    }
  }, [createProjectSuccess, createProjectData, isPmsOrder, pmsCommand]);

  useDidUpdateEffect(() => {
    if (!projectInitSuccess || !isPmsOrder) return;
    if (pmsCommand === pmsStartProject) {
      console.log('PMS] projectInitSuccess');

      console.log('PMS] project 생성을 위한 데이터 생성 시작');
      // const projectName = `${newPatientData?.firstName}'s 프로젝트`;
      const projectName = t('AUTO_PMS_PROJECT_NAME', {
        patientName: newPatientData?.firstName,
      });
      let clinicProjectId: string = makeCaseIdFnClinic({
        newDate: 0,
        patientName: newPatientData?.firstName,
        groupCode: loginUser.groupCode,
        caseCount: projectCount,
        caseIdValue: projectName,
      })(1);
      console.log('PMS] clinicProjectId __ ', clinicProjectId);
      let submitData: any = {
        exocadVersion: 3,
        userIdx: loginUser.userGroupIdx,
        projectId: clinicProjectId,
        projectName: projectName,
        dueDate: null,
        senderMemo: '',
        newDate: 0,
        patientCodeIdx: newPatientData?.patientCodeIdx,
        isMultidie: 0,
        participant: {
          client: loginUser?.userGroupIdx,
          manager: '',
          userIdx: loginUser?.userGroupIdx,
          partner: null,
        },
        copyProjectCode: '',
        copyProjectOption: [],
        remakeType: [],
        indication: {
          teeth: [],
          bridge: [],
          toothShade: 0,
          scanmodeIdx: 1,
          notation: 0,
          restorationPonticDesign: 0,
          ceramicMetalDesign: 0,
          occlusalSurfaceDesign: 0,
        },
      };
      console.log('PMS] project 생성 데이터 전달 __ ');
      ProjectActions.create_project_request(submitData);
    }
  }, [projectInitSuccess, projectCount, isPmsOrder, pmsCommand, newPatientData]);

  useDidUpdateEffect(() => {
    if (!newPatientSuccess || !isPmsOrder) return;
    if (pmsCommand === pmsStartProject) {
      console.log('PMS] newPatientSuccess ____ ', newPatient);
      setNewPatientData(newPatient);
      ProjectActions.init_project_request();
      console.log('PMS] project init Start ____ ');
    }
  }, [newPatientSuccess, newPatient, isPmsOrder, pmsCommand]);

  useEffect(() => {
    if (!ipcRenderer) return;
    handleCheckPmsFirstRun();
    ipcRenderer.on(pmsStartProject, (e: any, data: any) => {
      console.log('PMS] startProject _______ ', data.patientInfo);
      // if (!data.patientInfo || !isPmsReady) return;
      if (!data.patientInfo) return;
      PmsActions.pms_order(true);
      PmsActions.pms_command(pmsStartProject);
      PmsActions.pms_data({ patientInfo: data.patientInfo });
      // history.push(pageUrl.project.creatWaiting);
    });
    ipcRenderer.on(pmsViewThumbnail, (e: any, data: any) => {
      console.log('PMS] viewThumbnail _______ ', data.projectCode);
      // if (!data.projectCode || !isPmsReady) return;
      if (!data.projectCode) return;
      PmsActions.pms_order(true);
      PmsActions.pms_command(pmsViewThumbnail);
      PmsActions.pms_data({ projectCode: data.projectCode });
      // history.push(pageUrl.project.creatWaiting);
    });
  }, []);

  useEffect(() => {
    console.log('PMS] PMS isPmsOrder _______ ', isPmsOrder);
  }, [isPmsOrder]);
  useEffect(() => {
    console.log('PMS] PMS pmsCommand _______ ', pmsCommand);
  }, [pmsCommand]);
  useEffect(() => {
    console.log('PMS] PMS pmsData _______ ', pmsData);
  }, [pmsData]);

  useEffect(() => {
    if (!isUseablePms) return;
    console.log('PMS] 111111 _______________');
    if (!isClinicUser) {
      console.log('PMS] 2222222 _______________');
      openInaccessibleUserAlert();
    } else {
      console.log('PMS] 3333333 _______________');
      switch (pmsCommand) {
        case pmsStartProject:
          console.log('PMS] startProject start ]]]]]]]]]]]]]]]]]_________ ');
          const patient = {
            chartNumber: pmsData.patientInfo.ChartID,
            firstName: pmsData.patientInfo.Name,
            lastName: '',
            birthday: pmsData.patientInfo.Birthday,
            gender: pmsData.patientInfo.Gender,
            comment: '',
            identification: '',
            pms: 'DENTWEB',
          };
          PatientActions.new_patient_request(patient);
          break;
        case pmsViewThumbnail:
          console.log('PMS] viewThumbnail start ]]]]]]]]]]]]]]]]]_________ ', pmsData?.projectCode);
          const url = `/project/creating/${pmsData.projectCode}?pathTo=detail&tab=0`;
          history.push(url);
          break;

        default:
          break;
      }
    }
  }, [isUseablePms, isClinicUser, pmsCommand, pmsData]);

  useEffect(() => {
    if (
      !!isPmsOrder &&
      !!pmsCommand &&
      !!pmsData &&
      !!isLogIn &&
      !!userProfile &&
      location.pathname !== '/home'
    ) {
      setIsUseablePms(true);
    } else {
      setIsUseablePms(false);
    }
  }, [isPmsOrder, pmsCommand, pmsData, isLogIn, userProfile, location]);

  useEffect(() => {
    if (!ipcRenderer) return;
    handleAutoLogin();
  }, []);

  const handleAutoLogin = async () => {
    const isAutoLogin = await ipcRenderer.invoke('autoLoginAsync', {});

    if (!!isAutoLogin.autoLogin && !!isAutoLogin.accessToken) {
      signInUser(isAutoLogin.accessToken);
    }
  };

  const handleCheckPmsFirstRun = async () => {
    const getCommand = await ipcRenderer.invoke('getCommandLine', {});
    if (!getCommand.command || !getCommand.data) return;
    console.log('PMS] handleCheckCommand __________ ', getCommand);
    PmsActions.pms_order(true);
    PmsActions.pms_command(getCommand.command);
    PmsActions.pms_data(getCommand.data);
  };

  const openInaccessibleUserAlert = () => {
    AppActions.add_popup({
      isOpen: true,
      timeout: 0,
      title: t('GLOBAL_ANNOUNCEMENT'),
      disableBackdropClick: true,
      isCloseIconButton: false,
      content: (
        <div style={{ textAlign: 'center' }}>
          <T>ALERT_NOT_USE_PMS</T>
        </div>
      ),
      onClick: () => {
        signOut();
      },
    });
  };

  return null;
}

export default PmsConnect;

export const handleClearPmsData = () => {
  console.log('PMS] handleClearPmsData _________ ');
  PmsActions.pms_order(false);
  PmsActions.pms_command(null);
  PmsActions.pms_data(null);
  PmsActions.pms_ready(false);
};

export const testVeiwthumbnail_1 = (history: any) => {
  console.log('PMS] testVeiwthumbnail_1 _________ ');
  console.log('HDS] testVeiwthumbnail_1 _________ ');
  // history.push(pageUrl.project.creatWaiting);
  PmsActions.pms_ready(true);
  PmsActions.pms_order(true);
  PmsActions.pms_command(pmsViewThumbnail);
  PmsActions.pms_data({ projectCode: '4b43526f31a25d3595d882c6361fe612' });
};

export const testVeiwthumbnail_2 = (history: any) => {
  console.log('PMS] testVeiwthumbnail_2 _________ ');
  // history.push(pageUrl.project.creatWaiting);
  PmsActions.pms_order(true);
  PmsActions.pms_command(pmsViewThumbnail);
  PmsActions.pms_data({ projectCode: '414af36e77f7aa649a23f17707df7870' });
};

export const testVeiwthumbnail_3 = (history: any) => {
  console.log('PMS] testVeiwthumbnail_3 _________ ');
  // history.push(pageUrl.project.creatWaiting);
  PmsActions.pms_order(true);
  PmsActions.pms_command(pmsViewThumbnail);
  PmsActions.pms_data({ projectCode: '424ec2952cebf9319afc7a76774cd7c4' });
};
